import devFlagSlugs from '@/constants/devFlagSlugs';

function getDefaultDevFlagValuesFromSlugs() {
  return {
    ...Object.keys(devFlagSlugs).reduce((aggregate, currentValue) => ({
      ...aggregate,
      [devFlagSlugs[currentValue]]: false,
    }), {}),
  };
}

export const mutations = {
  setDevFlag(state, payload) {
    state.flags[payload.slug] = payload.value;
  },
};

const state = {
  flags: getDefaultDevFlagValuesFromSlugs(),
  devFlagSlugs,
};

export const actions = {
  updateDevFlag({
    commit,
  }, payload) {
    commit('setDevFlag', payload);
  },
};

const devFlags = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default devFlags;
